import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import ErrorTooltip from '../../../components/ErrorTooltip';
import Validation from '../../../utils/Validation';
import { isEmpty } from 'lodash';
import classNames from 'classnames';

const PhoneAndEmailInformation = (props) => {
  let {
    contactInfo,
    setContactInfo,
    errors,
    setErrors,
    lastEdited,
    confirmFieldValues,
    handleConfirmField,
    savedContactInfo,
  } = props;

  const [confirmField, setConfirmField] = useState('');

  useEffect(() => {
    initializeValues();
  }, []);

  useEffect(() => {
    validateAndSetErrors();
    toggleConfirmFields();
  }, [contactInfo.phone, contactInfo.email, confirmFieldValues]);

  const initializeValues = () => {
    contactInfo = {
      notificationAgreement: null,
      phone: '',
      email: '',
    };

    confirmFieldValues = {
      confirmPhone: '',
      confirmEmail: '',
    };

    setErrors({});
  };

  const toggleConfirmFields = () => {
    if (lastEdited === 'phone') {
      setConfirmField({
        ...confirmField,
        confirmPhone: contactInfo.phone.length > 0,
      });
    } else if (lastEdited === 'email') {
      setConfirmField({
        ...confirmField,
        confirmEmail: contactInfo.email.length > 0,
      });
    }
  };

  const validateAndSetErrors = () => {
    //Validation methods set possible errors to errorsState

    let errorsState = {};
    if (contactInfo.email != savedContactInfo.email) {
      Validation.validateEmailNoRequirement(
        contactInfo.email,
        confirmFieldValues.confirmEmail,
        errorsState
      );
    }
    if (contactInfo.phone != savedContactInfo.phone) {
      Validation.validatePhoneInAgreement(
        contactInfo.phone,
        confirmFieldValues.confirmPhone,
        errorsState
      );
    }
    setErrors(errorsState);
  };

  const handleChange = (event) => {
    setContactInfo(event);
  };

  const handleConfirmFieldChange = (event) => {
    handleConfirmField(event);
    validateAndSetErrors();
  };

  const handleBlur = () => {
    toggleConfirmFields();
    validateAndSetErrors();
  };

  return (
    <div className="ot-hpa-contact-info-container">
      <div className="ot-hpa-contact-field-group span6">
        {/* Phone number */}
        <label htmlFor="phone" className="control-label">
          <FormattedMessage id={'phone.number'}>
            {(txt) => (
              <span aria-disabled="true" className="label_text">
                {txt}
              </span>
            )}
          </FormattedMessage>

          <div className="controls">
            <input
              className={classNames(
                'control-group',
                errors.phone && 'ot-error'
              )}
              aria-required="true"
              id="phone"
              type="text"
              name="phone"
              onChange={handleChange}
              onBlur={handleBlur}
              value={contactInfo.phone}
            />
            {errors.phone && (
              <div className="ot-agreement-error">
                {errors.phone.map((error, index) => (
                  <ErrorTooltip key={index} error={error} />
                ))}
              </div>
            )}
            {errors.phoneConfirm && (
              <div className="ot-agreement-error">
                {errors.phoneConfirm.map((error, index) => (
                  <ErrorTooltip key={index} error={error} />
                ))}
              </div>
            )}
          </div>
        </label>

        {/* Confirm phone number */}
        {confirmField.confirmPhone && (
          <label htmlFor="confirmPhone" className="control-label">
            <FormattedMessage id={'confirm.phone.number'}>
              {(txt) => (
                <span aria-disabled="true" className="label_text">
                  {txt}
                </span>
              )}
            </FormattedMessage>

            <div className="controls">
              <input
                className={''}
                type="text"
                aria-required="true"
                id="confirmPhone"
                name="confirmPhone"
                onChange={handleConfirmFieldChange}
                onBlur={handleBlur}
                value={confirmFieldValues.confirmPhone}
              />
            </div>
          </label>
        )}
      </div>

      <div className="ot-hpa-contact-field-group span6">
        <div className="control-group">
          {/* Email */}
          <label htmlFor="email" className="control-label">
            <FormattedMessage id={'email'}>
              {(txt) => (
                <span aria-disabled="true" className="label_text">
                  {txt}
                </span>
              )}
            </FormattedMessage>

            <div className="controls">
              <input
                className={classNames(
                  'control-group',
                  errors.email && 'ot-error'
                )}
                id="email"
                type="text"
                name="email"
                onChange={handleChange}
                onBlur={handleBlur}
                value={contactInfo.email}
              />
              {errors.email && (
                <div className="ot-agreement-error">
                  {errors.email.map((error, index) => (
                    <ErrorTooltip key={index} error={error} />
                  ))}
                </div>
              )}
              {errors.emailConfirm && (
                <div className="ot-agreement-error">
                  {errors.emailConfirm.map((error, index) => (
                    <ErrorTooltip key={index} error={error} />
                  ))}
                </div>
              )}
            </div>
          </label>

          {/* Confirm email */}
          {confirmField.confirmEmail && (
            <label htmlFor="confirmEmail" className="control-label">
              <FormattedMessage id={'confirm.email'}>
                {(txt) => (
                  <span aria-disabled="true" className="label_text">
                    {txt}
                  </span>
                )}
              </FormattedMessage>

              <div className="controls">
                <input
                  className={''}
                  id="confirmEmail"
                  type="text"
                  name="confirmEmail"
                  onChange={handleConfirmFieldChange}
                  onBlur={handleBlur}
                  value={confirmFieldValues.confirmEmail}
                />
              </div>
            </label>
          )}
        </div>
      </div>
    </div>
  );
};

export default PhoneAndEmailInformation;
